// Import the Hero component for displaying the page banner
import Hero from "../../frontend/components/Hero";
// Import an image to use as the background for the Hero section
import CalculatorsImag1 from "../../assets/images/checking-data-laptop.jpg";
// Import the calculator component for Relevant Life Tax calculations
import RelevantLifeTaxCalculator from "../../frontend/components/calculators/RelevantLifeTaxCalculator";


// Main page component for the Relevant Life Tax calculator
const RelevantLifeTaxPage = () => {
  return (
    <div>
      {/* Hero section with title and background image */}
      <Hero
        title="Relevant Life Tax"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      {/* Render the Relevant Life Tax Calculator */}
      <RelevantLifeTaxCalculator />
      {/* Placeholder for additional content or layout, currently commented out */}
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

// Export the page component as default
export default RelevantLifeTaxPage;
